import type { ReactNode } from 'react';

type PageHeroProps = {
  eyebrow: string;
  title: ReactNode;
  subtitle?: string;
  image: string;
  compact?: boolean;
};

export default function PageHero({ eyebrow, title, subtitle, image, compact = false }: PageHeroProps) {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img src={image} alt="" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/75 to-background-50/60"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/80 via-background-50/30 to-transparent"></div>
      </div>
      <div className={`relative z-10 max-w-7xl mx-auto px-6 lg:px-8 ${compact ? 'pt-28 pb-10 lg:pt-32 lg:pb-12' : 'pt-40 pb-16 lg:pt-48 lg:pb-20'}`}>
        <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/40 bg-background-50/40 px-4 py-1.5 text-[12px] uppercase tracking-[0.2em] text-primary-300 backdrop-blur mb-6">
          <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
          {eyebrow}
        </span>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase leading-[1.0] tracking-tight text-foreground-50 max-w-4xl">
          {title}
        </h1>
        {subtitle && <p className="mt-6 max-w-2xl text-lg text-foreground-100/80">{subtitle}</p>}
      </div>
    </section>
  );
}